<template>
  <section class="home">
    <header class="headerCom">
      <img class="back"
           src="/images/public/back.png"
           @click='back'>
    </header>
    <div class='top_content'>
      <img src='/images/growth/moTop.png'>
    </div>

    <div class='card_content'>
      <div class='card'>
        <div class='card_title'>关于五金贴膜</div>
        <div class='list_title'><span class='dian'></span>什么是五金保护膜</div>
        <div class='list_content'>采用的是进口的PET材料，pet俗称涤纶树脂，这种材料100%透明无遮挡</div>
        <div class='list_title'><span class='dian'></span>五金保护膜的作用</div>
        <div class='list_content'>能保护包包使用过程中金属配件表面的划伤、磨损、灰尘污渍、氧化等现象（如果表面已经有的损伤、划痕、氧化现象，五金膜贴上是不具有修复翻新功能的，只有保护避免二次损伤的作用）</div>
        <div class='list_title'><span class='dian'></span>五金贴膜服务介绍</div>
        <div class='list_content'>我们提供五金保护膜贴膜服务，用户也可以直接购买五金保护膜。 </br>【贴膜服务】：我们将直接为包包提供，五金保护膜贴膜服务，需要寄包 </br>【购买贴膜】：仅购买五金保护膜，在简易教程指导下用户自行贴膜</div>
        <div class='list_title'><span class='dian'></span>五金贴膜保护案例</div>

        <div class='img_list_content'>
          <div class='list_item'>
            <img src='/images/growth/list1.png'>
            <div>未贴膜</div>
          </div>
          <div class='list_item'>
            <img src='/images/growth/list2.png'>
            <div>已贴膜</div>
          </div>
        </div>
        <div class='img_list_content'>
          <div class='list_item'>
            <img src='/images/growth/list3.png'>
            <div>未贴膜</div>
          </div>
          <div class='list_item'>
            <img src='/images/growth/list4.png'>
            <div>已贴膜</div>
          </div>
        </div>
      </div>

      <div class='card_list_item'
           v-for='(item,index) in list'
           :key='index'>
        <div class='list_top'>
          <img :src='item.pic'>
        </div>
        <div class='dero'>适用于·{{item.brand}}·五金保护膜</div>
        <div class='btn_content'>
          <div @click='toDetail(item.bid)'>贴膜服务</div>
          <div v-if='item.show'
               @click='look(item.scan,item)'>购买贴膜</div>
        </div>
      </div>
    </div>

    <transition name="van-fade"
                @touchmove.prevent>
      <div class='markShdow'
           @click='popupShow = false'
           v-if='popupShow'
           @touchmove.prevent>
        <div>
          <img src="/images/base/weChart.png"
               align="middle">
          <div class="qrcode-wrap">

            <img :src="imgpatch"
                 alt=""
                 @click.stop
                 class='img_select' />
          </div>
        </div>
      </div>
    </transition>

  </section>
</template>

<script>
import wxShare from "@/assets/js/wx.share"
import { Dialog } from 'vant';
import zhugeObj from '@/assets/js/track'
export default {
  name: 'metalFilm',
  data() {
    return {
      popupShow: false,
      imgpatch: '',
      list: [
        {
          pic: '/images/growth/lv.png',
          brand: 'LOUIS VUITTON',
          bid: '83',//包拯ID
          scan: '/images/scan/lv.png',//陈真二维码
          show: true,//是否展示跳转陈真按钮
        },
        {
          pic: '/images/growth/hermes.png',
          brand: 'HERMES',
          bid: '84',//包拯ID
          scan: '/images/scan/hermes.png',//陈真二维码
          show: true,//是否展示跳转陈真按钮
        },
        {
          pic: '/images/growth/gucci.png',
          brand: 'GUCCI',
          bid: '59',//包拯ID
          scan: '/images/scan/gucci.png',//陈真二维码
          show: true,//是否展示跳转陈真按钮
        },
        {
          pic: '/images/growth/dior.png',
          brand: 'DIOR',
          bid: '57',//包拯ID
          scan: '/images/scan/dior.png',//陈真二维码
          show: true,//是否展示跳转陈真按钮
        },
        {
          pic: '/images/growth/celine.png',
          brand: 'CELINE',
          bid: '77',//包拯ID
          scan: '/images/scan/celine.png',//陈真二维码
          show: true,//是否展示跳转陈真按钮
        },
        {
          pic: '/images/growth/mcm.png',
          brand: 'MCM',
          bid: '78',//包拯ID
          scan: '/images/scan/mcm.png',//陈真二维码
          show: true,//是否展示跳转陈真按钮
        },
        {
          pic: '/images/growth/ysl.png',
          brand: 'YSL',
          bid: '79',//包拯ID
          scan: '/images/scan/ysl.png',//陈真二维码
          show: true,//是否展示跳转陈真按钮
        },
        {
          pic: '/images/growth/chanel.png',
          brand: 'CHANEL',
          bid: '80',//包拯ID
          scan: '/images/scan/chanel.png',//陈真二维码
          show: true,//是否展示跳转陈真按钮
        },
        {
          pic: '/images/growth/furla.png',
          brand: 'FURLA',
          bid: '76',//包拯ID
          scan: '/images/scan/furla.png',//陈真二维码
          show: false,//是否展示跳转陈真按钮
        }
      ]
    }
  },
  computed: {

  },
  created() {
    zhugeObj.track({
      title: '五金贴膜—曝光',
    })
  },
  mounted() {
    setTimeout(() => {
      this.setShare();
    }, 100)
  },
  methods: {
    back() {
      this.$router.back();
    },
    look(path, item) {
      zhugeObj.track({
        title: '点击购买贴膜',
        content: {
          '品牌': item.brand,
        }
      })
      this.popupShow = true
      this.imgpatch = path;
    },
    setShare() {
      let shareBody = {
        desc: '要想包包一直bulingbuling，贴膜要趁早！',
        link: window.location.href,
        title: '邀请你加入“五金保护计划',
        imgUrl: 'http://mi.baozheng.cc/images/growth/moTop.png'
      };
      wxShare(shareBody);


    },
    toDetail(id) {
      zhugeObj.track({
        title: '点击贴膜详情',
        content: {
          'ID': id,
        }
      })
      this.$router.push({ name: 'serviceDetail', query: { serviceId: id } })
    }

  }
}
</script>

<style scoped lang="scss">
.img_select {
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}
.layer {
  border-radius: 10px !important;
}
.content {
  border-radius: 10px;
  padding: 20px;
}
.mypop {
  border-radius: 10px;
}
.title {
  height: 100px;
  line-height: 100px;
  text-align: center;
  font-size: 40px;
  color: #333;
}
.img_path {
  width: 500px;
}
.home {
  background: url("/images/growth/moBg.png") center;
  background-size: 100% 100%;
}
.top_content {
  position: relative;

  img {
    width: 100%;
    height: 700px;
  }
}
.card_content {
  padding-left: 32px;
  padding-right: 32px;
  position: relative;
  top: -40px;
  .card {
    padding: 60px 42px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 30px 0px rgba(209, 209, 209, 1);
    border-radius: 12px;
    position: relative;
  }
  .card_title {
    width: 300px;
    height: 74px;
    text-align: center;
    font-size: 36px;
    line-height: 74px;
    background: rgba(255, 137, 0, 1);
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    position: absolute;
    left: 42px;
    top: -37px;
  }
}
.list_title {
  margin-top: 20px;

  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(86, 86, 86, 1);
  line-height: 40px;
  .dian {
    color: #ff8900;
    display: inline-block;
    width: 10px;
    height: 10px;
    position: relative;
    top: -5px;
    margin-right: 14px;
    border-radius: 5px;
    background-color: #ff8900;
  }
}
.list_content {
  color: #9d9d9d;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 36px;
  margin-top: 8px;
}
.img_list_content {
  display: flex;
  justify-content: space-between;
  margin-top: 22px;
  .list_item {
    width: 280px;
    img {
      width: 100%;
    }
    div {
      text-align: center;
      margin-top: 24px;
      font-size: 24px;
      color: #9d9d9d;
    }
  }
}
.headerCom {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 60px;
  -webkit-transform: translateZ(0);
  padding-bottom: 20px;
  padding-top: 20px;
  .back {
    width: 60px;
    position: absolute;
    left: 30px;
    top: 20px;
  }
}
.card_list_item {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 30px 0px rgba(209, 209, 209, 1);
  border-radius: 12px;
  margin-top: 38px;
  padding: 40px;
  img {
    width: 100%;
  }
  .dero {
    font-size: 28px;
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .btn_content {
    display: flex;
    justify-content: space-between;
    div {
      width: 280px;
      background: #ff8900;
      height: 60px;
      font-size: 30px;
      line-height: 60px;
      text-align: center;
      color: #fff;
      border-radius: 30px;
    }
  }
}
.markShdow {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  z-index: 99;
}
.markShdow div {
  width: 100%;
  position: relative;
  margin-top: 200px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
}
.markShdow div > img {
  width: 100%;
}
.markShdow div .qrcode-wrap {
  position: absolute;
  bottom: 15px;
  width: 280px;
  height: 280px;
  background: red;
  left: 50%;
  margin-left: -140px;
}
</style>
